<script setup>
import { ref } from 'vue'
import { useHasBeenInViewport } from '@js/App/Performance/HasBeenInViewport'
import { isSSR } from '@js/App/Utils/Environment'

defineOptions({
  // This makes sure that the CSS class="" doesn't get put on the imageRef div, but only on the <img> tag.
  inheritAttrs: false
})

defineProps({
  src: {
    type: String
  },
  lazy: {
    type: Boolean,
    default: true
  },
  priority: {
    type: Boolean,
    default: false
  },
  fetchpriority: {
    type: String,
    default: 'auto',
    validator: value => ['high', 'low', 'auto'].includes(value)
  }

})

const imageRef = ref(null)
const { hasBeenInViewport } = useHasBeenInViewport(imageRef, 750)
</script>
<template>
  <div v-if="!priority && (isSSR() || !hasBeenInViewport)" ref="imageRef" />

  <img
    v-if="priority || !lazy || (hasBeenInViewport && !isSSR())"
    v-bind="$attrs"
    :src="src"
    :fetchpriority="fetchpriority"
  >
</template>
